/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Styles from './EmprestimoGarantiaCarroContratoVantagens.css';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function EmprestimoGarantiaCarroContratoVantagens() {
  return (
    <>
      <section id="emp-garantia-contrato-vantagens">
        <ContainerHome24>
          <h3 className="emp-garantia-contrato-vantagens-titulo">
            Confira as vantagens de antecipar suas parcelas
          </h3>
          <p className="emp-garantia-contrato-vantagens-subtitulo">
            Ao antecipar suas parcelas de empréstimo na Santander Financiamentos, você pode receber
            diversas vantagens.
          </p>
          <div className="emp-garantia-contrato-vantagens-cards">
            <div className="emp-garantia-contrato-vantagens-card">
              <img
                src="assets/emprestimo-garantia-carro-contrato/ic_checking_account_open.svg"
                alt=""
                className="emp-garantia-contrato-vantagens-card-img"
              />
              <p className="emp-garantia-contrato-vantagens-card-text">
                Você terá desconto em suas parcelas.
              </p>
            </div>
            <div className="emp-garantia-contrato-vantagens-card">
              <img
                src="assets/emprestimo-garantia-carro-contrato/ic_calendar_check.svg"
                alt=""
                className="emp-garantia-contrato-vantagens-card-img"
              />
              <p className="emp-garantia-contrato-vantagens-card-text">
                Você termina seu contrato de empréstimo antes.
              </p>
            </div>
            <div className="emp-garantia-contrato-vantagens-card">
              <img
                src="assets/meu-financiamento/ic_car.svg"
                alt=""
                className="emp-garantia-contrato-vantagens-card-img"
              />
              <p className="emp-garantia-contrato-vantagens-card-text">
                Você poderá realizar um novo empréstimo em menos tempo.
              </p>
            </div>
          </div>
          <WhiteButton
            href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
            className="btn-saiba-mais-emp-garantia-contrato-vantagens"
            target="_blank"
            rel="noopener"
          >
            Antecipar parcelas
          </WhiteButton>
        </ContainerHome24>
        <img
          src="assets/emprestimo-garantia-carro-contrato/img-emp-garantia-contrato-vantagens.svg"
          className="img-emp-garantia-contrato-vantagens"
          alt=""
        />
        <img
          src="assets/emprestimo-garantia-carro-contrato/img-emp-garantia-contrato-vantagens-desk.svg"
          className="img-emp-garantia-contrato-vantagens-desk"
          alt=""
        />
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroContratoVantagens;
